import React from 'react';
import Card from './Card';

const Services = () => {
    const services = [
        {
            icon: 'fa-compass',
            title: 'Digital Consulting & Advisory',
            items: ['Process mapping & re-engineering', 'Digital strategy & roadmaps', 'Operating model design']
        },
        {
            icon: 'fa-laptop-code',
            title: 'Custom Software Development',
            items: ['Web & mobile applications', 'Backend systems & APIs', 'Cloud-native solutions']
        },
        {
            icon: 'fa-robot',
            title: 'Process Automation & Hyper-Automation',
            items: ['RPA & Power Platform', 'OCR & document processing', 'Data pipelines & integrations']
        },
        {
            icon: 'fa-flask',
            title: 'Innovation Lab & Prototyping',
            items: ['Rapid prototypes & MVPs', 'UX testing & validation', 'Feasibility studies']
        },
        {
            icon: 'fa-chalkboard-teacher',
            title: 'Training & Capability Building',
            items: ['Workshops & on-site training', 'SOP development', 'Adoption programs']
        }
    ];

    return (
        <section id="services" style={{ padding: '80px 0', backgroundColor: '#f9fafb' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <span style={{ color: '#1746A2', fontWeight: 500 }}>What We Offer</span>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: '#0C1A36',
                        marginTop: '8px',
                        marginBottom: '16px'
                    }}>
                        Our Services
                    </h2>
                    <p style={{ color: '#4b5563', maxWidth: '600px', margin: '0 auto' }}>
                        Comprehensive digital solutions tailored to drive your business forward
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '16px auto 0'
                    }}></div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '32px'
                }}>
                    {services.map((service, index) => (
                        <Card
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                padding: '32px',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
                                border: '1px solid #f3f4f6'
                            }}
                        >
                            <div style={{
                                width: '64px',
                                height: '64px',
                                backgroundColor: '#0C1A36',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '24px'
                            }}>
                                <i className={`fas ${service.icon}`} style={{ fontSize: '24px', color: 'white' }}></i>
                            </div>
                            <h3 style={{
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#0C1A36',
                                marginBottom: '16px'
                            }}>
                                {service.title}
                            </h3>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {service.items.map((item, i) => (
                                    <li key={i} style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '8px',
                                        color: '#4b5563',
                                        marginBottom: '12px'
                                    }}>
                                        <i className="fas fa-check" style={{ color: '#1746A2', marginTop: '4px' }}></i>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </Card>
                    ))}

                    <Card
                        style={{
                            background: 'linear-gradient(135deg, #0C1A36, #1746A2)',
                            borderRadius: '12px',
                            padding: '32px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <h3 style={{ fontSize: '24px', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
                            Ready to Transform?
                        </h3>
                        <p style={{ color: '#e5e7eb', marginBottom: '24px' }}>
                            Let's discuss how we can help accelerate your digital journey.
                        </p>
                        <a
                            href="#contact"
                            style={{
                                backgroundColor: 'white',
                                color: '#0C1A36',
                                fontWeight: 500,
                                padding: '12px 24px',
                                borderRadius: '8px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '8px',
                                textDecoration: 'none',
                                width: 'fit-content',
                                transition: 'all 0.3s'
                            }}
                        >
                            <i className="fas fa-arrow-right"></i> Get Started
                        </a>
                    </Card>
                </div>
            </div>
        </section>
    );
};

export default Services;